import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';

import { useEffect, useMemo } from 'react';

import { uerContractWorkOrdersGql } from '../ContractQueries';

const requestId = 'uerContractWorkOrders';

export const useUerContractWorkOrders = (contractId?: number, withEffect = true) => {
    const [uerContractWorkOrdersReset] = useResetStoreData({ requestId });

    const variables = useMemo(() => ({ contractId }), [contractId]);

    const [uerContractWorkOrdersData, uerContractWorkOrdersStatus] = useRequest({
        requestId,
        query: uerContractWorkOrdersGql,
        variables,
        withEffect: !!contractId,
    });

    useEffect(() => {
        uerContractWorkOrdersReset(undefined);
    }, [uerContractWorkOrdersReset]);

    const items = useMemo(
        () => uerContractWorkOrdersData?.uerContractWorkOrders || [],
        [uerContractWorkOrdersData?.uerContractWorkOrders],
    );

    return {
        items,
        status: uerContractWorkOrdersStatus,
    };
};
